import React from 'react';


const IndustriesServiceExperienceSection = ({ title, industryTabs }) => {
    return (
        <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 relative">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 items-start">
                    <div className="w-full lg:w-[40%] lg:sticky lg:top-24">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                            {title}
                        </h2>
                    </div>

                    <div className="w-full lg:w-[60%] flex flex-col gap-6">
                        {industryTabs.map((item) => (
                            <div
                                key={item.id}
                                className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group text-left"
                            >
                                <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IndustriesServiceExperienceSection;